import { useFormikContext } from 'formik';
import { useMemo } from 'react';
import { useWorkflows } from '../../../../queries/hooks/useWorkflows';
import { Workflow, WorkflowStage } from '../../../../types';
import { IUserFileds } from './UserModal';

/**
 * Resolves the workflow currently selected in the form (by id) and derives which relation pickers it
 * requires. Manager / SVP Manager pickers are shown based on the selected workflow's approvalStages,
 * so each of the 10 workflows only asks for the relations its pipeline actually uses.
 */
export function useSelectedWorkflow() {
  const { data: workflows } = useWorkflows();
  const { values } = useFormikContext<IUserFileds>();

  const selectedWorkflow = useMemo<Workflow | undefined>(
    () => workflows?.find((workflow) => workflow.id === Number(values.workflow?.id)),
    [workflows, values.workflow?.id]
  );

  const stages = useMemo<WorkflowStage[]>(() => selectedWorkflow?.approvalStages ?? [], [selectedWorkflow]);

  return {
    workflows,
    selectedWorkflow,
    stages,
    hasManagerStage: stages.includes(WorkflowStage.MANAGER),
    hasSvpStage: stages.includes(WorkflowStage.SVP_MANAGER),
  };
}
